/**
 * ClientServiceContractTypeFetcher
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { Fetcher } from '../../fetchers/fetcher';

class ClientServiceContractTypeFetcher extends Fetcher {
    get modelName() {
        return 'Client Service Contract Type';
    }

    get resourceName() {
        return 'service-contracts/types';
    }

    selectOptions() {
        return this.all({
            fields: ['id', 'description'],
        }).then(result => this.generateSelectOptions(result.data));
    }

    generateSelectOptions(types) {
        types = types.map(type => {
            const details = type.hourly_rate ? this.$filter('currency')(type.hourly_rate / 100) + '/h' : null;

            return {
                id: type.id,
                label: type.description,
                value: type.id,
                details,
            };
        });

        types.sort((left, right) => {
            return left.label < right.label ? -1 : 1;
        });

        return types;
    }

    /**/
    /**/
}

export function serviceContractTypeFetcherProvider() {
    this.$get = instantiateFetcher;

    instantiateFetcher.$inject = ['$injector'];

    function instantiateFetcher($injector) {
        return $injector.instantiate(ClientServiceContractTypeFetcher);
    }
}
